import React from "react";
import PublicLegalPage from "./PublicLegalPage";

const PublicTermsConditions = () => (
  <PublicLegalPage
    apiPath="cms/terms"
    fallbackTitleEn="Terms & Conditions"
    fallbackTitleAr="الشروط والأحكام"
  />
);

export default PublicTermsConditions;
